<template>
  <van-loading v-if="loading && isHcpDetails" class="loading">
    加载中...
  </van-loading>
  <div v-else class="parting">
    <div>
      <CommonHeader
        v-if="isHcpDetails"
        title="观念分型"
        icon-url="/lundbeck/NBA/physician.png"
        :no-feedback="true"
      >
        <div slot="before">
          <img
            v-if="!isPhysicianFirst && canEditStatus"
            src="@/assets/lundbeck/NBA/edit.png"
            alt=""
            width="16"
            style="margin-top: 6px"
            @click="openPhysicianDialog()"
          />
        </div>
      </CommonHeader>
      <div v-if="isPhysicianFirst">
        <p class="tip-text">请先回答问题来确认医生观念分型</p>
        <Button
          v-if="canEditStatus"
          class="tip-button"
          round
          type="info"
          @click="openPhysicianDialog()"
        >
          立即进行问答
        </Button>
        <div style="height: 40px;"></div>
      </div>
      <div v-else>
        <div>
          <div class="parting-type">
            <div
              :class="
                resultType === '症状控制 - 初识'
                  ? 'parting-type-selected'
                  : 'parting-type-unselected'
              "
            >
              <div>
                <div v-if="resultType === '症状控制 - 初识'">
                  <img :src="star" alt="" width="14" />
                </div>
                <p>症状控制 - 初识</p>
              </div>
            </div>
            <div
              :class="
                resultType === '长期获益 - 尝试'
                  ? 'parting-type-selected'
                  : 'parting-type-unselected'
              "
            >
              <div>
                <div v-if="resultType === '长期获益 - 尝试'">
                  <img :src="star" alt="" width="14" />
                </div>
                <p>长期获益 - 尝试</p>
              </div>
            </div>
            <div
              :class="
                resultType === '长期获益 - 认可'
                  ? 'parting-type-selected'
                  : 'parting-type-unselected'
              "
            >
              <div>
                <div v-if="resultType === '长期获益 - 认可'">
                  <img :src="star" alt="" width="14" />
                </div>
                <p>长期获益 - 认可</p>
              </div>
            </div>
            <div
              :class="
                resultType === '长期获益 - 倡导'
                  ? 'parting-type-selected'
                  : 'parting-type-unselected'
              "
            >
              <div>
                <div v-if="resultType === '长期获益 - 倡导'">
                  <img :src="star" alt="" width="14" />
                </div>
                <p>长期获益 - 倡导</p>
              </div>
            </div>
          </div>
          <img src="@/assets/svg/xAxis.svg" alt="" style="width: 340px; margin-top: 10px;" />
          <!-- <div class="parting-type-x">
            <p>低</p>
            <p>医生对于长期获益的认可度</p>
            <p>高</p>
          </div> -->
        </div>

        <!-- 当前分型详情 -->
        <div class="parting-type-action">
          <div>
            <template v-if="resultType && segmentDetails[resultType]">
              <div v-for="(section, sectionIndex) in segmentDetails[resultType]" :key="sectionIndex" class="action-plan">
                <template v-for="(content, title) in section">
                  <div :key="title">
                    <div class="action-title">
                      <div class="title-flag"></div>
                      <span class="title-text">{{ title }}</span>
                    </div>
                    <div class="action-plan">
                      <template v-if="Array.isArray(content)">
                        <p v-for="(text, index) in content" :key="index" class="action-text">
                          <span class="action-flag"></span>
                          <span v-html="highlightText(text)"></span>
                        </p>
                      </template>
                      <template v-else>
                        <p class="action-text">
                          <span v-html="highlightText(content)"></span>
                        </p>
                      </template>
                    </div>
                  </div>
                </template>
              </div>
            </template>
          </div>
        </div>

        <!-- EDA -->
        <div v-if="false" class="parting-type-action">
          <div class="action-plan">
            <div class="action-title">
              <div class="title-flag"></div>
              <span class="title-text">相关资料</span>
            </div>
            <div class="eda-content action-plan">
              <p
                v-for="(eda, idx) in edas[resultType] || []"
                :key="eda.title + idx"
                class="action-text flex"
              >
                <span class="flex-1">
                  <span class="action-flag"></span>
                  <span>{{ eda.title }}</span>
                  <span class="key-message-labels" style="display: block;">
                    <span v-for="(tag, tagIdx) in eda.tags" :key="tagIdx">{{ tag }}</span>
                  </span>
                </span>
                <span>
                  <img
                    src="@/assets/lundbeck/NBA/preview.png"
                    alt=""
                    width="26"
                    style="margin-left: 4px;"
                    @click="previewImage(eda.file || '')"
                  />
                </span>
              </p>
            </div>
          </div>
        </div>

        <!-- 模拟演练 Roleplay -->
        <div v-if="false && isHcpDetails" class="roleplay-section nba-pannel">
          <p class="nba-title">模拟场景演练</p>
          <div class="custom-select" @click="showRoleplayPicker = true">
            <span class="label">
              <span class="roleplay-avatar">
                <img
                  src="@/assets/lundbeck/roleplay-hcp.png"
                  style="display:block;"
                />
              </span>
            </span>
            <span v-if="selectedRoleplay" class="value">{{ selectedRoleplay }}</span>
            <span v-else class="placeholder">请选择场景</span>
            <van-icon name="arrow-down" class="select-arrow" />
          </div>
          <van-popup v-model="showRoleplayPicker" position="bottom" round>
            <div style="max-height: 60vh; overflow-y: auto; padding: 16px;">
              <van-radio-group v-model="tempRoleplay">
                <van-radio
                  v-for="scene in roleplayScenes"
                  :key="scene"
                  :name="scene"
                  style="white-space: normal; line-height: 1.5; margin-bottom: 16px;"
                >
                  {{ scene }}
                </van-radio>
              </van-radio-group>
              <div style="text-align:right;margin-top:16px;">
                <van-button size="small" @click="showRoleplayPicker = false">取消</van-button>
                <van-button size="small" type="primary" style="margin-left:8px" @click="onRoleplayConfirm(tempRoleplay)">确定</van-button>
              </div>
            </div>
          </van-popup>
          <div v-if="selectedRoleplay" class="roleplay-speech">
            <div class="speech-title">推荐话术</div>
            <div class="custom-select">
              <span class="value">
                <ol>
                  <li v-for="(item, idx) in roleplaySpeech[selectedRoleplay]" :key="idx">{{ item }}</li>
                </ol>
              </span>
              <span class="label">
                <span class="roleplay-avatar">
                  <img
                    src="@/assets/lundbeck/roleplay-mr.png"
                    style="display:block;"
                  />
                </span>
              </span>
            </div>
          </div>
          <div class="flex" style="align-items: center;">
            <div style="width: 33%"></div>
            <div class="roleplay-ai-link" style="width: 33%">跳转到AI陪练</div>
            <div style="width: 33%; font-size: 12px;">评估总分：<span style="color: #aa341b; font-size: 16px;">98</span></div>
          </div>
        </div>

      </div>
    </div>

    <div>
      <van-dialog
        v-model="physicianDialogShow"
        title="医生分型问答"
        theme="round-button"
        confirm-button-color="#aa341b"
        :before-close="beforePhysicianClose"
        @confirm="confirmPhysicianAnswer()"
      >
        <div class="diglog-close" @click="closeDiglog()">×</div>
        <div class="diglog-questions">
          <!-- Question 1 -->
          <div class="question">
            <p class="question-text">
              1. 是否为PD专诊？
              <span style="color: #cc4b47">*</span>
            </p>
            <van-radio-group
              v-model="questionAnswers.firstAnswer"
              direction="horizontal"
              class="answer"
            >
              <van-radio name="true" style="margin-right: 30%">是</van-radio>
              <van-radio name="false">否</van-radio>
            </van-radio-group>
            <p v-if="physicianAnswerTips && !questionAnswers.firstAnswer" class="error">
              这是必答题，请选择答案！
            </p>
          </div>
          <!-- Question 2 -->
          <div class="question">
            <p class="question-text">
              2. 是否D类客户？
              <span style="color: #cc4b47">*</span>
            </p>
            <van-radio-group
              v-model="questionAnswers.secondAnswer"
              direction="horizontal"
              class="answer"
            >
              <van-radio name="true" style="margin-right: 30%">是</van-radio>
              <van-radio name="false">否</van-radio>
            </van-radio-group>
            <p v-if="physicianAnswerTips && !questionAnswers.secondAnswer" class="error">
              这是必答题，请选择答案！
            </p>
          </div>
          <!-- Question 3 -->
          <div class="question">
            <p class="question-text">
              3. 每月门诊/病房接受药物治疗的PD患者有多少？（人次/月）
              <span style="color: #cc4b47">*</span>
            </p>
            <van-field
              v-model="questionAnswers.thirdAnswer"
              type="number"
              placeholder="请输入人数"
              class="answer"
            />
            <p v-if="physicianAnswerTips && !questionAnswers.thirdAnswer" class="error">
              这是必答题，请选择答案！
            </p>
          </div>
          <!-- Question 4 -->
          <div class="question">
            <p class="question-text">
              4. 其中新诊断为PD并接受药物治疗的患者有多少？（人次/月）
              <span style="color: #cc4b47">*</span>
            </p>
            <van-field
              v-model="questionAnswers.fourthAnswer"
              type="number"
              placeholder="请输入人数"
              class="answer"
            />
            <p v-if="physicianAnswerTips && !questionAnswers.fourthAnswer" class="error">
              这是必答题，请选择答案！
            </p>
          </div>
          <!-- Question 5 -->
          <div class="question">
            <p class="question-text">
              5. 每月诊断为PD并接受药物治疗的患者中，使用雷沙吉兰的患者占比？
              <span style="color: #cc4b47">*</span>
            </p>
            <van-radio-group
              v-model="questionAnswers.fifthAnswer"
              direction="vertical"
              class="answer"
            >
              <van-radio name="0">0</van-radio>
              <van-radio name="0-10%">0-10%</van-radio>
              <van-radio name="10-20%">10-20%</van-radio>
              <van-radio name="20-30%">20-30%</van-radio>
              <van-radio name=">30%">>30%</van-radio>
            </van-radio-group>
            <p v-if="physicianAnswerTips && !questionAnswers.fifthAnswer" class="error">
              这是必答题，请选择答案！
            </p>
          </div>
          <!-- Question 6 -->
          <div class="question">
            <p class="question-text">
              6. 医生观念区隔 - 疾病治疗理念
              <span style="color: #cc4b47">*</span>
            </p>
            <van-radio-group
              v-model="questionAnswers.sixthAnswer"
              direction="vertical"
              class="answer"
              @change="questionAnswers.seventhAnswer = null"
            >
              <van-radio name="long-term-benefit">
                更关注患者长期获益，而不仅仅是短期快速控制症状
              </van-radio>
              <van-radio name="symptom-control">
                关注患者快速控制运动波动
              </van-radio>
            </van-radio-group>
            <p v-if="physicianAnswerTips && !questionAnswers.sixthAnswer" class="error">
              这是必答题，请选择答案！
            </p>
          </div>
          <!-- Question 7 -->
          <div class="question">
            <p class="question-text">
              <span v-if="questionAnswers.sixthAnswer === 'long-term-benefit'">7. 医生观念区隔 - 长期获益型产品观念</span>
              <span v-else>7. 医生观念区隔 - 症状控制型产品观念</span>
              <span style="color: #cc4b47">*</span>
            </p>
            <van-radio-group
              v-model="questionAnswers.seventhAnswer"
              direction="vertical"
              class="answer"
            >
              <van-radio v-if="questionAnswers.sixthAnswer === 'long-term-benefit'" name="advocate">
                在长期获益上，我认为MAO-BI优于DA
              </van-radio>
              <van-radio v-if="questionAnswers.sixthAnswer === 'long-term-benefit'" name="trial">
                在长期获益上，我认为MAO-BI和DA没有显著差别
              </van-radio>
              <van-radio v-if="questionAnswers.sixthAnswer !== 'long-term-benefit'" name="initial">
                在症状控制上，我认为MAO-BI和DA差不多
              </van-radio>
              <van-radio v-if="questionAnswers.sixthAnswer !== 'long-term-benefit'" name="da-prefer">
                在症状控制上，我认为DA显著优于MAO-BI
              </van-radio>
            </van-radio-group>
            <p v-if="physicianAnswerTips && !questionAnswers.seventhAnswer" class="error">
              这是必答题，请选择答案！
            </p>
          </div>
        </div>
      </van-dialog>
    </div>
    <swipeDialog
      v-if="pdfLink"
      backtxt="返回"
      :title="'预览'"
      @closeFn="closePdfFn"
    >
      <pdf v-if="pdfLink" :src="pdfLink" />
    </swipeDialog>

    <CommonHeader
      v-if="false && isHcpDetails"
      title="行动建议"
      icon-url="/lundbeck/NBA/physician.png"
      :no-feedback="true"
    />
    <div v-if="false && isHcpDetails" class="nba-pannel">
      <div class="visit-kpi-box">
        <div class="visit-kpi-title">拜访任务</div>
        <div class="visit-kpi-row">
          <div class="visit-kpi-item">
            <div class="visit-kpi-label">本月目标</div>
            <div class="visit-kpi-value">{{ visitTarget }}</div>
          </div>
          <div class="visit-kpi-item">
            <div class="visit-kpi-label">本月已拜访</div>
            <div class="visit-kpi-value">{{ visitDone }}</div>
          </div>
          <van-button
            type="primary"
            size="small"
            class="visit-kpi-btn"
            @click="goToVisit"
          >前往拜访</van-button>
        </div>
      </div>
      <p class="nba-title">线上任务</p>
      <TaskList
        :tasks="tasks"
        @sendTask="sendTask"
        @ignoreTask="ignoreTask"
      />
    </div>
  </div>
</template>

<script>
import CommonHeader from '@/components/CommonHeader';
import {Button, RadioGroup, Radio, Loading, ImagePreview, Field, Popup, Picker, Icon} from 'vant';
import * as py from '@/api/Physicians';
import {getLocalStorage} from '@/utils';
import pdf from 'vue-pdf';
import swipeDialog from '@/views/layout/swipeDialog';
import TaskList from './TaskList.vue';

export default {
  name: 'Azilect',
  components: {
    CommonHeader,
    Button,
    vanRadioGroup: RadioGroup,
    vanRadio: Radio,
    swipeDialog,
    vanLoading: Loading,
    pdf,
    TaskList,
    vanField: Field,
    vanPopup: Popup,
    vanButton: Button,
    vanIcon: Icon,
    // vanPicker: Picker,
  },
  props: {
    physicianId: String,
    productId: {
      type: String,
      default() {
        return '';
      },
    },
    showActions: {
      type: Boolean,
      default() {
        return true;
      },
    },
    showOfflineActions: {
      type: Boolean,
      default() {
        return true;
      },
    },
  },
  data() {
    return {
      loading: false,
      isPhysicianFirst: true,
      physicianDialogShow: false,
      questionAnswers: {
        firstAnswer: null,
        secondAnswer: null,
        thirdAnswer: null,
        fourthAnswer: null,
        fifthAnswer: null,
        sixthAnswer: null,
        seventhAnswer: null,
      },
      physicianPartings: [],
      physicianAnswerTips: false,
      physicianSelectedParting: '',
      star: require('@/assets/lundbeck/star.png'),
      showType: '',
      numPages: 0,
      pdfLink: '',
      pdfKey: '',
      detailStatus: false,
      fileLoading: false,
      canEditStatus: false,
      resultType: '',
      segmentDetails: {
        '症状控制 - 初识': [
          {
            '转化目标': '强调长期获益重要性。对于步态障碍患者优选MAO-BI进行治疗，安齐来对于运动波动的控制优势以及安全性。推进方向是：LD首选添加安齐来，或者 LD+DA+安齐来',
          },
          {
            '核心障碍': '认为尽快控制症状更重要，DA对于运动症状控制优于MAO-BI',
          },
          { '传递关键信息': [
            '步态障碍控制优选MAO-BI《帕金森病步态障碍的管理策略》',
            '运动波动，安全性《帕金森病运动波动的临床识别与管理》',
            '传递长期获益重要性(神经保护）',
          ] },
        ],
        '长期获益 - 尝试': [
          {
            '转化目标': '强调长期获益重要性；强调在神经保护/疾病修饰上MAO-BI优于DA；强调安齐来对于运动波动的控制优势以及安全性。推进方向： 使用LD出现运动波动的患者首选添加安齐来',
          },
          {
            '核心障碍': '虽然将长期获益作为其处方决策的重要因素，但是觉得在神经保护/疾病修饰等方面DA和MAO-BI相当',
          },
          { '传递关键信息': [
            '长期获益的重要性（神经保护）',
            'MAO-BI神经保护/疾病修饰优于DA《区隔DA-优化帕金森病全程管理》',
            '运动波动，安全性《帕金森病运动波动的临床识别与管理》',
          ] },
        ],
        '长期获益 - 认可': [
          {
            '转化目标': '强化安齐来在疗效和安全性方面的优势，区隔咪多比。推进方向是：使用LD出现运动波动的患者首选添加安齐来',
          },
          {
            '核心障碍': '认可咪多比，不认为安齐来疗效与安全性占优。',
          },
          { '传递关键信息': [
            '长期获益的重要性(神经保护）',
            '疗效与安全性全面占优《区隔司来吉兰——雷沙吉兰在帕金森病治疗中的应用》',
          ] },
        ],
        '长期获益 - 倡导': [
          {
            '转化目标': '强化安齐来在疗效和安全性方面的优势，建立初始治疗的新选择，早期患者首选安齐来',
          },
          {
            '核心障碍': '追求疗效和安全性的平衡。',
          },
          { '传递关键信息': [
            '长期获益的重要性(神经保护）',
            '安齐来可提供长期获益',
            '疗效与安全性平衡',
          ] },
        ],
      },
      campaigns: {
        '症状控制 - 初识': [
          {
            'title': 'PD Quality Control',
          },
          {
            'title': 'Starfish Club',
          },
          {
            'title': 'Parkinson Disease D&T management project',
          },
          {
            'title': 'CME Elite',
          },
        ],
        '长期获益 - 尝试': [
          {
            'title': 'PD Quality Control',
          },
          {
            'title': 'Starfish Club',
          },
          {
            'title': 'Parkinson Disease D&T management project',
          },
          {
            'title': 'CME Elite',
          },
        ],
        '长期获益 - 认可': [
          {
            'title': 'PD Quality Control',
          },
          {
            'title': 'Starfish Club',
          },
          {
            'title': 'Parkinson Disease D&T management project',
          },
          {
            'title': 'CME Elite',
          },
        ],
        '长期获益 - 倡导': [
          {
            'title': 'PD Quality Control',
          },
          {
            'title': 'Starfish Club',
          },
          {
            'title': 'Parkinson Disease D&T management project',
          },
          {
            'title': 'CME Elite',
          },
        ],
      },
      edas: {
        '症状控制 - 初识': [
          {
            'title': 'PD经典研究：从结果回溯研究设计',
            'tags': ['学术会议', 'CNCT-002651'],
          },
          {
            'title': '区隔DA——优化帕金森病全程管理',
            'tags': ['学术会议', 'CNCT-003238'],
          },
          {
            'title': '区隔-MAO-B抑制剂在PD治疗中的优化应用',
            'tags': ['学术会议', 'CNCT-002694'],
          },
          {
            'title': '2023科室会幻灯-安齐来® （雷沙吉兰）帕金森病治疗的新选择',
            'tags': ['科室会', 'CNCT-002393'],
          }
        ],
        '长期获益 - 尝试': [
          {
            'title': 'PD经典研究：从结果回溯研究设计',
            'tags': ['学术会议', 'CNCT-002651'],
          },
          {
            'title': '区隔DA——优化帕金森病全程管理',
            'tags': ['学术会议', 'CNCT-003238'],
          }
        ],
        '长期获益 - 认可': [
          {
            'title': 'PD经典研究：从结果回溯研究设计',
            'tags': ['学术会议', 'CNCT-002651'],
          },
          {
            'title': '区隔DA——优化帕金森病全程管理',
            'tags': ['学术会议', 'CNCT-003238'],
          }
        ],
        '长期获益 - 倡导': [
          {
            'title': 'PD经典研究：从结果回溯研究设计',
            'tags': ['学术会议', 'CNCT-002651'],
          },
          {
            'title': '区隔DA——优化帕金森病全程管理',
            'tags': ['学术会议', 'CNCT-003238'],
          }
        ],
      },
      tasks: [
        // {
        //   type: '直播',
        //   time: '4月17日 19:00 - 20:00',
        //   campaign: 'D&T management project',
        //   title: '2025帕金森病国际学术峰会',
        //   hcp_name: '陈博',
        //   thumb: 'https://hcp360-mobile.lundbecksys.cn/api/aws/S3/GetFile?bucketName=pim-prod&key=live/live-pd-20250511/live-pd-20250511-banner.jpg',
        //   segment: '症状控制 - 初识',
        //   target: '强调长期获益重要性',
        //   km: '安齐来可提供长期获益',
        // },
        // {
        //   type: '推文',
        //   time: '4月18日',
        //   campaign: 'PD&T management project',
        //   title: '《大咖对话｜帕金森病诊疗「新战场」：如何改写 47% 误诊困局？》',
        //   hcp_name: '胡琦',
        //   segment: '症状控制 - 初识',
        //   target: '强调长期获益重要性',
        //   km: '安齐来可提供长期获益',
        //   isWechat: true,
        // }
      ],
      showRoleplayPicker: false,
      selectedRoleplay: '',
      tempRoleplay: '',
      roleplayScenes: [
        '没有将长期获益作为治疗决策的关键因素，认为应该快速症状控制',
        '将长期获益作为处方的重要决策因素',
        '认为在运动症状的控制上DA优于安齐来，觉得DA起效更快',
        '认为在疗效和安全性上安齐来与咪多比差不多，且咪多比更便宜'
      ],
      roleplaySpeech: {
        '没有将长期获益作为治疗决策的关键因素，认为应该快速症状控制': [
          '长期获益对于患者生活质量和疾病进展有重要影响，建议在治疗决策中综合考虑。',
          '快速症状控制固然重要，但长期疗效和安全性同样值得关注。'
        ],
        '将长期获益作为处方的重要决策因素': [
          '安齐来在长期随访中显示出良好的疗效和安全性，适合需要长期管理的患者。',
          '选择长期获益更优的药物，有助于患者的整体康复和依从性提升。'
        ],
        '认为在运动症状的控制上DA优于安齐来，觉得DA起效更快': [
          'DA类药物起效快，但安齐来在运动症状控制和长期安全性方面也有优势。',
          '可以根据患者具体情况，权衡起效速度与长期管理的平衡。'
        ],
        '认为在疗效和安全性上安齐来与咪多比差不多，且咪多比更便宜': [
          '安齐来在部分患者中显示出更好的耐受性和依从性。',
          '除了价格，疗效和安全性也是选择药物的重要考量。'
        ]
      },
      visitTarget: 7,
      visitDone: 0,
    };
  },
  computed: {
    nbaPhysicianId() {
      return this.physicianId ?? this.$route.query.physician_id;
    },
    isHcpDetails() {
      return !this.physicianId;
    },
  },
  mounted() {
    if (getLocalStorage('territory_type') === 'MR') {
      this.canEditStatus = true;
    }
    this.getPhysicianTyping();
    // wecomSDK.register();
  },
  methods: {
    getPhysicianTyping() {
      this.loading = true;
      let params = {
        physician_id: this.nbaPhysicianId,
        product_id: this.productId,
        territory_id: getLocalStorage('territory_id'),
      };
      py.getPhysicianTyping(params).then((res) => {
        if (res && res.value.length) {
          this.physicianPartings = res.value;

          if (this.physicianPartings.length > 0) {
            this.isPhysicianFirst = false;
            this.questionAnswers = JSON.parse(
              this.physicianPartings[0].content,
            );
            this.resultType = this.physicianPartings[0].result;
          } else {
            this.isPhysicianFirst = true;
          }
        }
        this.loading = false;
      });
    },
    getPhysicianType() {
      let result = "";
      this.physicianSelectedParting = "D";

      if (this.questionAnswers.sixthAnswer === 'long-term-benefit') {
        if (this.questionAnswers.seventhAnswer === 'advocate') {
          if (this.questionAnswers.fifthAnswer === '>30%') {
            this.physicianSelectedParting = "A";
          } else {
            this.physicianSelectedParting = "B";
          }
        } else if (this.questionAnswers.seventhAnswer === 'trial') {
          this.physicianSelectedParting = "C";
        }
      } else if (this.questionAnswers.sixthAnswer === 'symptom-control') {
        this.physicianSelectedParting = "D";
      }

      switch (this.physicianSelectedParting) {
        case "A":
          result = "长期获益 - 倡导";
          break;
        case "B":
          result = "长期获益 - 认可";
          break;
        case "C":
          result = "长期获益 - 尝试";
          break;
        case "D":
          result = "症状控制 - 初识";
          break;
      }
      return result;
    },
    openPhysicianDialog() {
      this.physicianAnswerTips = false;
      if (this.isPhysicianFirst) {
        this.questionAnswers = {
          firstAnswer: null,
          secondAnswer: null,
          thirdAnswer: null,
          fourthAnswer: null,
          fifthAnswer: null,
          sixthAnswer: null,
          seventhAnswer: null,
        };
      }
      if (this.physicianPartings.length > 0) {
        this.questionAnswers = JSON.parse(this.physicianPartings[0].content);
      }
      this.physicianDialogShow = true;
    },
    beforePhysicianClose(action, done) {
      if (action === 'confirm' && this.physicianDialogShow) {
        done(false);
      } else {
        done();
      }
    },
    closeDiglog() {
      this.physicianDialogShow = false;
    },
    confirmPhysicianAnswer() {
      if (
        this.questionAnswers.firstAnswer == null ||
        this.questionAnswers.secondAnswer == null ||
        this.questionAnswers.thirdAnswer == null ||
        this.questionAnswers.fourthAnswer == null ||
        this.questionAnswers.fifthAnswer == null ||
        this.questionAnswers.sixthAnswer == null ||
        this.questionAnswers.seventhAnswer == null
      ) {
        this.physicianAnswerTips = true;
        return;
      }
      this.resultType = this.getPhysicianType();
      let uName = getLocalStorage('user_name');
      let params = {
        physician_id: this.nbaPhysicianId,
        content: JSON.stringify(this.questionAnswers),
        user_id: getLocalStorage('user_id'),
        territory_id: getLocalStorage('territory_id'),
        create_time: Date.parse(new Date()),
        product_id: this.productId,
        result: this.resultType,
        modify_user_id: getLocalStorage('user_id'),
        modify_user_name: uName !== 'null' ? uName : getLocalStorage('user_id'),
      };
      py.setPhysicianTyping(params).then((res) => {
        if (res.is_success) {
          this.$toast.success('提交成功');
          this.hospitalDialogShow = false;
          setTimeout(() => {
            this.getPhysicianTyping();
          }, 2);
        }
      });
      this.physicianDialogShow = false;
    },
    previewImage(slides) {
      console.log(slides);
      if (slides.indexOf('.pdf') > 0) {
        this.lookPdfDetail('/resource/nba/azilect/' + slides);
      } else {
        let images = [];
        slides.split(',').forEach((image) => {
          images.push('/resource/nba/azilect/' + image);
        });
        ImagePreview({
          images: images,
          loop: false,
          showIndicators: true,
        });
      }
    },
    lookPdfDetail(url) {
      this.$store.dispatch('setDialogStatus', true);
      this.detailStatus = true;
      this.pdfLink = url;
    },
    closePdfFn() {
      this.$store.dispatch('setDialogStatus', false);
      this.pdfLink = null;
    },
    closeFn() {
      this.$store.dispatch('setDialogStatus', false);
      this.detailStatus = false;
      this.pdfLink = null;
      this.pdfKey = null;
    },
    highlightText(text) {
      // 将文本中的关键信息用highlight class标记
      return text.replace(/【(.+?)】/g, '<span class="highlight">$1</span>');
    },
    sendTask(task) {
      // 处理发送任务的逻辑
      console.log('Send task:', task);
    },
    ignoreTask(task) {
      // 处理忽略任务的逻辑
      console.log('Ignore task:', task);
    },
    onRoleplayConfirm(val) {
      this.selectedRoleplay = val;
      this.showRoleplayPicker = false;
    },
    goToVisit() {
      // 跳转到拜访页面
      this.$router.push({ path: '/hcp/visit-create', query: { physician_id: this.nbaPhysicianId } });
    },
  },
};
</script>

<style lang="scss" scoped>
.parting {
  .tip-text {
    font-size: 14px;
    font-family: Arial;
    font-weight: 400;
    color: #2c3034;
    opacity: 1;
    margin: 40px auto 20px;
  }
  .tip-button {
    width: 160px;
    height: 40px;
    background: #aa341b;
    border: 1px solid #aa341b;
    opacity: 1;
    border-radius: 500px;
    margin-bottom: 20px;
  }
  .diglog-close {
    position: absolute;
    font-size: 30px;
    top: 25px;
    right: 20px;
  }
  .diglog-questions {
    max-height: 480px;
    overflow-y: auto;
    padding: 20px 20px 0 20px;
    .question {
      margin-bottom: 20px;
      .question-text {
        font-size: 14px;
        font-family: Arial;
        font-weight: 700;
        line-height: 1.5;
        color: #2c3034;
        opacity: 1;
        text-align: left;
        margin-bottom: 10px;
      }
      // .answer {
      //   display: flex;
      //   justify-content: center;
      // }
    }
    .highlight {
      font-weight: 700;
      color: #aa341b;
    }
    .error {
      font-size: 14px;
      text-align: left;
      margin-top: 5px;
      color: #aa341b;
    }
  }
  .parting-type {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
    font-size: 12px;
    .parting-type-unselected {
      width: 98px;
      height: 80px;
      background: linear-gradient(46deg, #f8f6f5 0%, #f3e6e3 100%);
      opacity: 1;
      border-radius: 4px;
      margin: 3px;
      display: flex;
      align-items: center;
      justify-content: center;
      p {
        width: 50px;
        line-height: 1.5;
        color: #aa341b;
      }
    }
    .parting-type-selected {
      display: flex;
      align-items: center;
      width: 98px;
      height: 100px;
      background: linear-gradient(46deg, #aa341b 0%, #aa341b 100%);
      opacity: 1;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      p {
        width: 50px;
        line-height: 1.5;
        color: #ffffff;
      }
    }
  }
  .parting-type-x {
    display: flex;
    justify-content: space-around;
    color: #838a95;
    p {
      display: inline-block;
    }
  }

  .title-flag {
    width: 6px;
    height: 12px;
    background: #aa341b;
    opacity: 1;
    border-radius: 4px;
  }
  .title-text {
    height: 22px;
    font-size: 14px;
    font-family: Arial;
    font-weight: 700;
    color: #2c3034;
    opacity: 1;
    margin-left: 5px;
  }
  .parting-type-action {
    margin-top: 2px;
  }
  .action-title {
    display: flex;
    align-items: baseline;
    height: 20px;
  }
  .action-plan {
    padding: 10px 10px;
  }
  .action-flag {
    display: inline-block;
    width: 6px;
    height: 6px;
    background: #aa341b;
    opacity: 1;
    border-radius: 4px;
    margin: 0 5px 2px 0;
  }
  .action-text {
    font-size: 14px;
    font-family: Arial;
    font-weight: 400;
    color: #2c3034;
    opacity: 1;
    text-align: left;
    line-height: 1.3;
    margin-bottom: 10px;
  }
  .key-message-content-type > span {
    background: rgba(236, 233, 223, 0.5);
    border-radius: 20px;
    font-size: 11px;
    color: #333;
    white-space: nowrap;
    padding: 3px 8px;
    margin: 0 2px 0 0;
  }
  .key-message-labels > span {
    background: rgba(236, 233, 223, 0.5);
    border-radius: 20px;
    font-size: 11px;
    color: #333;
    white-space: nowrap;
    padding: 3px 8px;
    margin: 0 2px 0 0;
  }
  .action-highlight {
    font-size: 15px;
    font-family: Arial;
    font-weight: 700;
    color: #aa341b;
    opacity: 1;
    text-align: left;
    line-height: 1.2;
    margin-bottom: 15px;
    .action-flag {
      background: #aaa;
    }
    span {
      font-weight: 700;
    }
  }
  .bold {
    font-weight: 700;
    span {
      font-weight: 700;
    }
  }
  .action-tag {
    color: #ab351c;
  }
  .highlight {
    color: #aa341b;
  }
  .action-progress {
    display: flex;
    align-items: center;
    height: 30px;
    background: rgba(236, 233, 223, 0.5);
    border-radius: 4px;
    margin-bottom: 20px;
    p {
      color: #aa341b;
      font-size: 14px;
      font-family: Arial;
      font-weight: 700;
      margin-left: 10px;
    }
  }
  .download {
    z-index: 1;
    position: absolute;
    top: 450px;
    right: 20px;
    border: 1px solid rgb(218, 217, 217);
    border-radius: 100%;
    padding: 5px;
  }
  .proof-link {
    h4 {
      font-size: 14px;
      font-family: Arial;
      font-weight: bold;
      color: #2c3034;
      margin: 10px 0 20px;
      padding: 0;
    }
  }
  .eda-content {
    text-align: left;
    margin-bottom: 20px;

    .link {
      line-height: 1.5;
    }
  }
}
.loading {
  margin-top: 55%;
}
.reject-box {
  width: 50vw;
  padding: 15px;

  .reject-prompt {
    font-size: 14px;
    color: #666;
  }
  .answer {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    margin: 10px;
    ::v-deep .van-checkbox__label,
    ::v-deep .van-radio__label {
      font-size: 14px;
      text-align: left;
      margin: 4px;
    }
  }
  .reject-button {
    width: 150px;
    height: 36px;
    opacity: 1;
    border-radius: 500px;
    margin: 20px auto;
    display: block;
  }
  .textarea {
    width: 100%;
    padding: 5px;
    box-sizing: border-box;
    border-radius: 4px;
    font-size: 15px;
    color: #666;
  }
}
.nba-pannel {
  margin: -10px 0 -2px 0;
  padding: 8px;
  background-color: #f8f6f2;
  border-radius: 0 0 10px 10px;
  .nba-title {
    padding: 2px 0 10px 0;
    margin: 0;
    font-size: 12px;
    display: block;
    font-weight: 700;
    color: #aa341b;
    text-align: center;
  }
  .action-text {
    padding: 10px;
    margin-bottom: 8px;
    border-radius: 8px;
    background-color: #ffffff;
    &:last-child {
      margin-bottom: 0;
    }
  }
}
.van-cell {
  padding: 0;
}
.van-radio {
  margin-bottom: 5px;
}
::v-deep .van-radio__label {
  text-align: left;
  font-size: 14px;
}
.roleplay-section {
  margin: 0 8px 40px 8px;
  border-radius: 10px;

  .custom-select {
    display: flex;
    align-items: center;
    min-height: 44px;
    padding: 8px 4px;
    position: relative;
    cursor: pointer;
    .label {
      color: #888;
      flex-shrink: 0;
    }
    .value, .placeholder {
      flex: 1;
      white-space: normal;
      word-break: break-all;
      background: #fff;
      border-radius: 8px;
      padding: 10px 14px;
      color: #222;
      font-size: 14px;
      text-align: left;
      line-height: 1.2;
    }
    .placeholder {
      color: #bbb;
    }
    .select-arrow {
      margin-left: 8px;
      color: #bbb;
      font-size: 18px;
      flex-shrink: 0;
    }
  }
  .speech-title {
    font-weight: bold;
    margin: 12px 0 4px 0;
    color: #aa341b;
  }
  ol {
    text-align: left;;
    padding-left: 15px;
    margin: 0;
    list-style: decimal;
    li {
      font-size: 14px;
      color: #2c3034;
      margin-bottom: 6px;
      line-height: 1.2;
      list-style: decimal;
    }
  }
  .roleplay-avatar {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    background: #fbeee3;
    border-radius: 50%;
    margin-right: 8px;
    img {
      height: 48px;
    }
  }
  .roleplay-ai-link {
    margin: 10px auto;
    background: #fff;
    padding: 8px 8px;
    color: #aa341b;
    border-radius: 40px;
    border: 1px solid #aa341b;
    text-align: center;
    font-size: 14px;
    width: 120px;
  }
}
.visit-kpi-box {
  .visit-kpi-title {
    color: #aa341b;
    font-weight: bold;
    font-size: 12px;
    margin-bottom: 10px;
  }
  .visit-kpi-row {
    display: flex;
    align-items: center;
    gap: 18px;
    padding: 10px 20px;
    margin-bottom: 18px;
    border-radius: 8px;
    background-color: #ffffff;
  }
  .visit-kpi-item {
    flex: 0 0 auto;
    .visit-kpi-label {
      color: #888;
      font-size: 13px;
      margin-bottom: 2px;
    }
    .visit-kpi-value {
      color: #2c3034;
      font-size: 18px;
      font-weight: bold;
    }
  }
  .visit-kpi-btn {
    margin-left: auto;
    background: #aa341b;
    border-radius: 20px;
    font-size: 14px;
    padding: 0 18px;
    height: 32px;
    line-height: 32px;
    border: none;
  }
}
</style>
